<template>
	<box :customer="true" :autoLoad="true" :ref="boxRef" :title="title" :width="1000" :index="0" @hide="hide"
		@submit="submit" moduleName="supplier" :store="store" selectType="radio" @boxdataload="boxdataload" />
</template>
<style scoped>
	/* 	.footer_button {
		position: relative;
		width: 100%;
		flex-direction: row;
		align-items: flex-end;
		justify-content: flex-end;
		margin-top: 10px;
	} */
</style>
<script>
	//https://detail.tmall.com/item.htm?id=706822484836&spm=a21dvs.23580594.0.0.1d293d0d88sla5 
	import box from '@_system/components/formcomponents/common/box/index.vue'
	export default {
		props: {
			store: {
				type: Object,
				default: () => {
					return {}
				}
			}
		},
		data() {
			return {
				title:'选择供应商',
				index: 0,
				foreingKey: null,
				boxRef: 'box_' + Math.random(),
				box: null,
			}
		},
		created() {

		},
		mounted() {
			let box = this.$refs[this.boxRef]
			box.buttonShow = false
			this.box = box
			// this.box.list = this.list
			// this.box.show = this.show

		},
		watch: {

		},
		computed: {
			device() {
				return window.systemMethods.device()
			}
		},

		methods: {
			boxdataload(e) {
				this.$emit('boxdataload', e)
			},
			submit(e) {
				this.$emit('submit', e)
			},
			hide() {
				this.$emit('back')
			}
		},
		components: {
			box
		}
	}
</script>